import { put } from 'redux-saga/effects';
import { videoCommentsFetchErrorAction, videoCommentsFetchSuccessAction } from '../actions';
import { fetchVideoCommentsApi } from '../../../../common/api/videos';

export function* fetchVideoCommentsEffect({ payload }) {
  try {
    const response = yield fetchVideoCommentsApi(payload.videoId);
    yield put(videoCommentsFetchSuccessAction(response, response.length));
  } catch (error) {
    yield put(videoCommentsFetchErrorAction());
  }
}
